import React, { useRef, memo,useEffect,useState } from 'react'

import { BASE_URL2 } from 'config/axios'

import LabelCardHome from './LabelCardHome'
import MultiFabricLabelsHome from './MultiFabricLabelsHome'
import { FrLogo, ZaraQr } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as HursanHecho } from 'assets/zarahome/hursanhecho.svg'



const Page2 = ({ data,SizeData,isHursan,isZorlu }) => {
  const additionalPhrases = data.additionalPhrases
  // isHursan true ise additionalPhrases'ın kaç kart olacağını hesapla
  const calculateAdditionalPhrasesCardCount = () => {
    if (!isHursan) return 0;
    
    if (additionalPhrases.length === 0) {
      return 1; // Boş card
    }
    
    let cardCount = 0;
    for (let i = 0; i < additionalPhrases.length; i += 2) {
      const first = additionalPhrases[i];
      const second = additionalPhrases[i + 1];
      const totalLength = (first?.text?.length || 0) + (second?.text?.length || 0);
      const isTooLong = totalLength > 800;
      
      if (!second || isTooLong) {
        cardCount += 1; // İlk eleman için kart
        if (second && isTooLong) {
          cardCount += 1; // İkinci eleman varsa ve çok uzunsa, onun için de kart
        }
      } else {
        cardCount += 1; // ÇİFT kart (tek kart içinde iki içerik)
      }
    }
    return cardCount;
  };
  
  const additionalPhrasesCardCount = calculateAdditionalPhrasesCardCount();
  
  // isHursan true ise MultiFabricLabelsHome'a offset geç
  const { cards: originalCards, lastNumber } = MultiFabricLabelsHome({ data, SizeData, isHursan,isZorlu })
  
  // isHursan true ise cards'ın numaralarını offset ile güncelle
  const cards = isHursan && additionalPhrasesCardCount > 0
    ? originalCards.map((card, index) => {
        // Her card'ın number prop'unu bul ve offset ekle
        if (card.props && typeof card.props.number === 'number') {
          return React.cloneElement(card, {
            ...card.props,
            number: card.props.number + additionalPhrasesCardCount
          });
        }
        return card;
      })
    : originalCards;
  
  // isHursan true ise additionalPhrases lastNumber'dan başlar
  // Normal durumda currentNumber lastNumber ile başlar
  let currentNumber = lastNumber
  
  const { referance } = useOrderStore()
  const ref = useRef(null)
  const isBlackLabel = referance?.backgroundColor === 'B'
  const [isSymbolTranslate, setIsSymbolTranslate] = useState(!!data.symbolTranslate)
  const symbol = data?.washingLabel[0]?.symbol
  const washingAdditionalPhrases = data.washingAdditionalPhrases

  const totalLabelCount = ref.current?.children.length + 2


  const [isEmptyLabel, setIsEmptyLabel] = useState(false);
  const [filteredWashingAdditionalPhrases, setFilteredWashingAdditionalPhrases] = useState(washingAdditionalPhrases);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (ref.current) {
        setIsSymbolTranslate(data.symbolTranslate)
        const totalLabelCount = ref.current.children.length + 2;
        const newIsEmptyLabel =
          (isSymbolTranslate && totalLabelCount % 2 === 0) || 
          (!isSymbolTranslate && totalLabelCount % 2 === 1);
          setIsEmptyLabel(newIsEmptyLabel);
        // isEmptyLabel state'ini güncelle
        
        // Opsiyonel: Toplam etiket sayısını göstermek için alert
      }
      // Buraya çalışmasını istediğin kodu yaz
    }, 1000); // 3000ms = 3 saniye

    // Temizlik: component unmount olursa timeout iptal edilir
    return () => clearTimeout(timer);
  }, []); // Boş dependency array => sadece bir kez (component mount olunca) çalışır

  useEffect(() => {
    const filtered = (data.sizeGroup.variant === 'rugg' && SizeData) 
      ? washingAdditionalPhrases.slice(1) 
      : washingAdditionalPhrases;
    setFilteredWashingAdditionalPhrases(filtered);
  }, [data.sizeGroup.variant, SizeData, washingAdditionalPhrases]);

  /*<LabelCardHome type="front" number={currentNumber++}  >
  <div className="flex items-center h-full ">
    <div className="pl-[13mm] pr-[12mm] pb-[0.5mm] w-full">
    <div className="w-[27mm]">
<FrLogo 
className={`w-full h-auto ${isBlackLabel ? 'fill-white' : 'fill-[#1d1d1b]'}`} 
/>
</div>          </div>
  </div>
</LabelCardHome>
*/

  // isHursan true ise additionalPhrases için özel render fonksiyonu
  const renderAdditionalPhrasesForHursan = () => {
    if (additionalPhrases.length > 0) {
      const additionalCards = [];
      let localNumber = currentNumber;

      for (let i = 0; i < additionalPhrases.length; i += 2) {
        const first = additionalPhrases[i];
        const second = additionalPhrases[i + 1];

        // Her iki içerik birleştirildiğinde çok uzunsa ayrı kartlar olarak bas
        const totalLength = (first?.text?.length || 0) + (second?.text?.length || 0);
        const isTooLong = totalLength > 800;

        if (!second || isTooLong) {
          // İlk eleman için kart
          additionalCards.push(
            <div key={i} className="flex flex-col justify-center gap-1 mb-2">
              <LabelCardHome isHursan={isHursan} type={localNumber % 2 === 0 ? 'front' : 'back'} number={localNumber++}>
                <div className="flex flex-col items-center justify-center h-full w-full">
                  <div
                    className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                      first.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                    }`}
                    style={{ maxWidth: '360px' }}
                  >
                    {first.text}
                  </div>
                </div>
              </LabelCardHome>
            </div>
          );
          
          // Eğer ikinci eleman varsa ve çok uzunsa, onun için de ayrı kart oluştur
          if (second && isTooLong) {
            additionalCards.push(
              <div key={i + 1} className="flex flex-col justify-center gap-1 mb-2">
                <LabelCardHome isHursan={isHursan} type={localNumber % 2 === 0 ? 'front' : 'back'} number={localNumber++}>
                  <div className="flex flex-col items-center justify-center h-full w-full">
                    <div
                      className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                        second.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                      }`}
                      style={{ maxWidth: '360px' }}
                    >
                      {second.text}
                    </div>
                  </div>
                </LabelCardHome>
              </div>
            );
          }
        } else {
          // ÇİFT Kart Render (alt alta) - normal durum
          additionalCards.push(
            <div key={i} className="flex flex-col justify-center gap-15 mb-15">
              <LabelCardHome isHursan={isHursan} type={localNumber % 2 === 0 ? 'front' : 'back'} number={localNumber++}>
                <div className="flex flex-col items-center justify-center h-full w-full">
                  <div
                    className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                      first.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                    }`}
                    style={{ maxWidth: '360px',marginBottom:4 }}
                  >
                    {first.text}
                  </div>

                  <div
                    className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                      second.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                    }`}
                    style={{ maxWidth: '360px' }}
                  >
                    {second.text}
                  </div>
                </div>
              </LabelCardHome>
            </div>
          );
        }
      }

      // currentNumber'ı güncelle
      currentNumber = localNumber;

      return additionalCards;
    } else {
      // Additional phrases boşsa ama isHursan true ise boş card ekle
      const number = currentNumber++;
      return (
        <div key="empty-additional" className="flex flex-col justify-center gap-1 mb-2">
          <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
            <div className="flex flex-col items-center justify-center h-full w-full">
            </div>
          </LabelCardHome>
        </div>
      );
    }
  };

  // isHursan true ise tüm içeriği topla ve her satırın başına SVG ekle
  const renderGridContent = () => {
    if (!isHursan) {
      // isHursan false ise normal render
      return (
        <>
          {/* isHursan true ise additionalPhrases en başta */}
          {isHursan && renderAdditionalPhrasesForHursan()}
          
          {cards}
          
          {/* Normal zamanlarda additionalPhrases burada (eski davranış) */}
          {!isHursan && additionalPhrases.length > 0 && (
            renderAdditionalPhrasesNormal()
          )}

          {filteredWashingAdditionalPhrases.length > 0 && renderWashingAdditionalPhrases()}
        </>
      );
    }

    // isHursan true ise: tüm içeriği topla ve her satırın başına SVG ekle
    const additionalPhrasesArray = renderAdditionalPhrasesForHursan();
    const cardsArray = Array.isArray(cards) ? cards : (cards ? [cards] : []);
    const washingPhrasesArray = filteredWashingAdditionalPhrases.length > 0 
      ? (renderWashingAdditionalPhrases() || []) 
      : [];
    
    const allItems = [
      ...(Array.isArray(additionalPhrasesArray) ? additionalPhrasesArray : (additionalPhrasesArray ? [additionalPhrasesArray] : [])),
      ...cardsArray,
      ...washingPhrasesArray
    ].filter(Boolean);

    // Her 2 öğeyi bir grup olarak al ve her grupta sırayı tersine çevir (sağdaki sola, soldaki sağa)
    const reorderedItems = [];
    for (let i = 0; i < allItems.length; i += 2) {
      const first = allItems[i];
      const second = allItems[i + 1];
      
      // Eğer ikinci öğe varsa, yerlerini değiştir (sağdaki sola, soldaki sağa)
      if (second) {
        reorderedItems.push(second, first);
      } else {
        // Tek öğe kaldıysa olduğu gibi ekle
        reorderedItems.push(first);
      }
    }

    // Helper fonksiyon: React element'ini klonlayıp içindeki LabelCardHome'ların type prop'unu güncelle
    const updateLabelCardType = (element, newType) => {
      if (!element || !React.isValidElement(element)) {
        return element;
      }

      // Eğer bu element LabelCardHome ise (isHursan prop'u varsa), type prop'unu güncelle
      if (element.props && element.props.isHursan !== undefined && element.props.type !== undefined) {
        return React.cloneElement(element, { ...element.props, type: newType });
      }

      // Eğer children varsa, onları da recursive olarak kontrol et
      if (element.props && element.props.children) {
        const children = React.Children.map(element.props.children, (child) => {
          return updateLabelCardType(child, newType);
        });
        return React.cloneElement(element, { ...element.props, children });
      }

      return element;
    };

    return reorderedItems.map((item, index) => {
      const isStartOfRow = index % 2 === 0; // Her satırın başında (0, 2, 4, 6...)
      // Grid pozisyonuna göre type belirle: sol taraftakiler front, sağ taraftakiler back
      const gridType = index % 2 === 0 ? 'front' : 'back';
      
      // Item içindeki LabelCardHome'ların type prop'unu grid pozisyonuna göre güncelle
      const updatedItem = updateLabelCardType(item, gridType);
      
      return (
        <div key={index} style={{ position: 'relative' }}>
          {isStartOfRow && (
            <HursanHecho 
              width="240mm" 
              height="25mm" 
              style={{ 
                position: "absolute", 
                top: "0", 
                left: "0",
                zIndex: 1
              }} 
            />
          )}
          {updatedItem}
        </div>
      );
    });
  };

  // Normal additionalPhrases render fonksiyonu
  const renderAdditionalPhrasesNormal = () => {
    if (!additionalPhrases.length) return null;
    const cards = [];
    for (let i = 0; i < additionalPhrases.length; i += 2) {
      const first = additionalPhrases[i];
      const second = additionalPhrases[i + 1];
      const number = currentNumber++;
      // first yoksa atla
      if (!first) continue;

      const totalLength = (first?.text?.length || 0) + (second?.text?.length || 0);
      const isTooLong = totalLength > 780;
      
      // second yoksa, sadece first için kart oluştur
      if (!second) {

        cards.push(
          <div key={i} className="flex flex-col justify-center gap-1 mb-2">
            <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    first?.text?.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {first?.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );
      }
      // second varsa ve çok uzunsa, her ikisi için ayrı kartlar oluştur
      else if (second && isTooLong) {
        const secondNumber = currentNumber++;
        cards.push(
          <div key={i} className="flex flex-col justify-center gap-1 mb-2">
            <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    first?.text?.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {first?.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );

        cards.push(
          <div key={i + 1} className="flex flex-col justify-center gap-1 mb-2">
            <LabelCardHome isHursan={isHursan} type={secondNumber % 2 === 0 ? 'back' : 'front'} number={secondNumber}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    second?.text?.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {second?.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );
      }
      // second varsa ve çok uzun değilse, tek kart içinde ikisi birlikte
      else if (second && !isTooLong) {
 
        cards.push(
          <div key={i} className="flex flex-col justify-center gap-15 mb-15">
            <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    first?.text?.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px',marginBottom:4 }}
                >
                  {first?.text}
                </div>

                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    second?.text?.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {second?.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );
      }
    }
    return cards;
  };

  // Washing additional phrases render fonksiyonu
  const renderWashingAdditionalPhrases = () => {
    if (filteredWashingAdditionalPhrases.length === 0) return null;
    
    const cards = [];
    for (let i = 0; i < filteredWashingAdditionalPhrases.length; i += 2) {
      const first = filteredWashingAdditionalPhrases[i];
      const second = filteredWashingAdditionalPhrases[i + 1];
      const number = currentNumber++;

      const totalLength = (first?.text?.length || 0) + (second?.text?.length || 0);
      const isTooLong = totalLength > 800;

      if (!second || isTooLong) {
        cards.push(
          <div key={i} className="flex flex-col justify-center gap-1 mb-2">
            <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    first.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {first.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );
      } else {
        cards.push(
          <div key={i} className="flex flex-col justify-center gap-1 mb-2">
            <LabelCardHome isHursan={isHursan} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
              <div className="flex flex-col items-center justify-center h-full w-full">
                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    first.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px', marginBottom: '2mm' }}
                >
                  {first.text}
                </div>

                <div
                  className={`flex flex-col px-[2.5mm] font-arial text-justify tracking-[-0.02em] ${
                    second.text.length > 400 ? 'text-[6pt] leading-[6pt]' : 'text-[6pt] leading-[6pt]'
                  }`}
                  style={{ maxWidth: '360px' }}
                >
                  {second.text}
                </div>
              </div>
            </LabelCardHome>
          </div>
        );
      }
    }
    return cards;
  };

  return (
    <div 
      className={isHursan ? "" : "flex flex-wrap gap-y-3 gap-x-5"} 
      ref={ref} 
      style={
        isHursan
          ? {
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              justifyContent: "flex-start",
              gap: "0",
              marginLeft:-70
            }
          : { justifyContent: "center" }
      }
    >
      {renderGridContent()}






    </div>
  )
}

export default memo(Page2)
